import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { faFolderOpen, faCog, faTable, faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faMap } from '@fortawesome/free-regular-svg-icons';

// Add the imported icons to the library
library.add(faFolderOpen, faMap, faTable, faCog, faChartBar);

const folderOpen = icon({ prefix: 'fas', iconName: 'folder-open' });
const map = icon({ prefix: 'far', iconName: 'map' });
const table = icon({ prefix: 'fas', iconName: 'table' });
const cog = icon({ prefix: 'fas', iconName: 'cog' });
const chartBar = icon({ prefix: 'fas', iconName: 'chart-bar' });

import * as bootstrap from 'bootstrap';
import 'bootstrap5-toggle';

import '../../src/styles/style.css';
import '../../src/styles/theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap5-toggle/css/bootstrap5-toggle.min.css';

import { renderHeader } from '../components/project-header';
import { renderFooter } from '../components/footer';

import '../modules/intercomp';

/*import interfaces*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;

// Render header
const headerContainer = document.getElementById('header');
if (headerContainer instanceof HTMLDivElement) {
    headerContainer.appendChild(renderHeader());
}

// index
document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
<div class="container" id="nomenu" style="display: none;">${folderOpen.html}</i>This project is empty</div>
<div class="main-content">
    <div id="main-row" class="row h-100">
        <div class="col-xxl-2 col-lg-3 col-12">
            <div id="expContainer" class="left-box">
                <div id="menu-experiment"></div>
                <div id="info-experiment">
                    <div id="description-experiment"></div>
                </div>
            </div>
            <div id="data-policy" class='left-box'></div>
        </div>
        <div class="col-xxl-8 col-lg-9 col-12">
        <div id="menu"></div>
          <div id="main-content">
              <div class='row h-50'>
                  <div class='col-md-6 col-sm-6 col-12 dynamic-chart'>
                    <input id="mapToggle" type="checkbox" data-toggle="toggle" data-onlabel='${map.html}' data-offlabel='${table.html}' checked>
                      <div id="mapCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
                          <div class="carousel-inner">
                              <div class="carousel-item active">
                                  <div id="stationForm">
                                      <form method="post" autocomplete="off" action="javascript:update(\" station", $(\"form").serialize().split('=')[1].replace(' +',''))">
                                          <div class="input-group">
                                              <input class="form-control" id="statForm" type="text" name="myStation" placeholder="Search for a station" onkeyup="CheckKey(event, 'stationForm')" style="height: 28px">
                                              <div class="btn-group">
                                                  <button type="button" class="btn btn-light btn-xs" data-bs-toggle="dropdown" aria-label="Map Options" aria-haspopup="true" aria-expanded="false" id="mapButOptions" style="padding: 2px 4px; ">
                                                    ${cog.html}
                                                  </button>
                                                  <div id="mapMenu" class="dropdown-menu dropdown-menu-right"></div>
                                              </div>
                                          </div>
                                      </form>
                                  </div>
                                  <div id='iniLoader'></div>
                                  <div id='map'></div>
                              </div>
                              <div class="carousel-item">
                                  <div id='mapTable'></div>
                              </div>
                          </div>
                          <div id='hoverLoaderMap'>
                            <svg class="hoverSvg" viewBox="0 0 16 16">
                                <circle r="8" cx="8" cy="8" />
                            </svg>
                        </div>
                      </div>
                  </div>
                  <div class='col-md-6 col-sm-6 col-12 dynamic-chart'>
                    <input id="regStatToggle" type="checkbox" data-toggle="toggle" data-onlabel='${chartBar.html}' data-offlabel='${table.html}' checked>
                      <div id="regStatCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
                          <div class="carousel-inner">
                              <div class="carousel-item active">
                                  <div id='regStat'></div>
                                  <div id='hoverLoaderReg'>
                                      <svg class="hoverSvg" viewBox="0 0 16 16">
                                          <circle r="8" cx="8" cy="8" />
                                      </svg>
                                  </div>
                              </div>
                              <div class="carousel-item">
                                  <div id='regStatTable'></div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row h-50">
                  <div id="tsInfo"></div>
                  <div id="tsWeekly"></div>
                  <div id="tsGranularity"></div>
                  <div id="containerTS" class="col-md-6 col-sm-6 col-12 dynamic-chart">
                      <div id="intercomp-ts" ></div>
                  </div>
                  <div id ="containerScat" class="col-md-6 col-sm-6 col-12 dynamic-chart">
                    <input id="scatHistoToggle" type="checkbox" data-toggle="toggle" data-onlabel="<svg width='20px' height='20px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path fill-rule='evenodd' clip-rule='evenodd' d='M4 4C4.55228 4 5 4.44772 5 5V18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V5C3 4.44772 3.44772 4 4 4ZM11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5ZM13.5 14C14.3284 14 15 13.3284 15 12.5C15 11.6716 14.3284 11 13.5 11C12.6716 11 12 11.6716 12 12.5C12 13.3284 12.6716 14 13.5 14ZM20 5.5C20 6.32843 19.3284 7 18.5 7C17.6716 7 17 6.32843 17 5.5C17 4.67157 17.6716 4 18.5 4C19.3284 4 20 4.67157 20 5.5ZM13.5 10C14.3284 10 15 9.32843 15 8.5C15 7.67157 14.3284 7 13.5 7C12.6716 7 12 7.67157 12 8.5C12 9.32843 12.6716 10 13.5 10ZM19 12.5C19 13.3284 18.3284 14 17.5 14C16.6716 14 16 13.3284 16 12.5C16 11.6716 16.6716 11 17.5 11C18.3284 11 19 11.6716 19 12.5ZM7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z' fill='#000000'/>
</svg>" data-offlabel="<svg width='20px' height='20px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path fill-rule='evenodd' clip-rule='evenodd' d='M12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6V16C10 16.5523 10.4477 17 11 17C11.5523 17 12 16.5523 12 16V6ZM9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9V16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V9ZM15 9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V9ZM18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13V16C16 16.5523 16.4477 17 17 17C17.5523 17 18 16.5523 18 16V13ZM6 15C6 14.4477 5.55228 14 5 14C4.44772 14 4 14.4477 4 15V16C4 16.5523 4.44772 17 5 17C5.55228 17 6 16.5523 6 16V15ZM21 15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15V16C19 16.5523 19.4477 17 20 17C20.5523 17 21 16.5523 21 16V15ZM4 18C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18H4Z' fill='#000000'/>
</svg>" checked>
                    <div id="scatCarousel" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                            <input id="scatAxisToggle" type="checkbox" data-toggle="toggle" data-onlabel="log" data-offlabel='lin'>
                            <div id='scat'></div>
                            </div>
                            <div class="carousel-item">
                                <div id='histogram'></div>
                            </div>
                            <div class="carousel-item">
                                <div id='profiles'></div>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
</div>
`;

// Render header
const footerContainer = document.getElementById('footer');
if (footerContainer instanceof HTMLDivElement) {
    footerContainer.appendChild(renderFooter());
}

document.addEventListener('DOMContentLoaded', () => {
    // Prevent default action on clicking element with id "main"
    document.getElementById('main')?.addEventListener('click', (e) => {
        e.preventDefault();
    });

    // Define carousel options
    const carousels = ['map', 'regStat', 'scat'];
    for (const carousel of carousels) {
        const myCarousel = document.querySelector(`#${carousel}Carousel`);
        if (myCarousel instanceof HTMLElement) {
            const carouselInstance = new bootstrap.Carousel(myCarousel, {
                interval: false,
                touch: false,
            });

            // Store the carousel instance for later use
            (myCarousel as any)['bootstrapCarouselInstance'] = carouselInstance;
        }
    }

    // Function to handle toggle changes
    function handleToggleChange(toggleId: string, carouselId: string) {
        const toggle = document.getElementById(toggleId) as HTMLInputElement;
        const carouselElement = document.getElementById(carouselId);

        if (!toggle || !carouselElement) return;

        const carouselInstance = (carouselElement as any)['bootstrapCarouselInstance'] as bootstrap.Carousel;

        if (!carouselInstance) return;

        let isSliding = false;

        // Fires right before the slide starts
        carouselElement.addEventListener('slide.bs.carousel', () => {
            isSliding = true;
            toggle.disabled = true; // disable the toggle until slide ends
        });

        // Fires after the slide transition is complete
        carouselElement.addEventListener('slid.bs.carousel', () => {
            isSliding = false;
            toggle.disabled = false; // re-enable toggle
        });

        toggle.addEventListener('change', () => {
            if (isSliding) return; // ignore clicks during slide
            if (toggle.checked) {
                carouselInstance.prev();
            } else {
                carouselInstance.next();
            }
        });
    }

    // Handle map toggle change
    handleToggleChange('mapToggle', 'mapCarousel');

    // Handle regStat toggle change
    handleToggleChange('regStatToggle', 'regStatCarousel');

    // Handle scatHisto toggle change
    handleToggleChange('scatHistoToggle', 'scatCarousel');


    // Prevent propagation of click event on element with id "mapOptions"
    document.addEventListener('click', (e) => {
        const mapOptionsDropdown = document.getElementById('mapOptions') as HTMLElement;
        const isMapOptionsDropdown = mapOptionsDropdown && mapOptionsDropdown.contains(e.target as Node);
        if (isMapOptionsDropdown) {
            e.stopPropagation();
        }
    });

    // initialize bootstrap toggles
    document.querySelectorAll("[data-toggle='toggle']").forEach((element) => {
        (element as any).bootstrapToggle({
            onstyle: aeroval.settings.theme,
            offstyle: aeroval.settings.theme,
            size: 'small',
        });
    });
});
